import { useForm } from "react-hook-form";
import { google_logo } from "../../assets";
import { ButtonCustom, InputField, ModelNext } from "../../components";
import { useEffect, useState } from "react";
import { useLoginApi, useLoginWithSocialApi } from "../../hooks";
import toast from "react-hot-toast";
import { TLogin } from "../../types";
import withRouter from "../../hocs/withRouter";
import path from "../../ultils/path";
import { useAuthStore, useRememberStore } from "../../store";
import {
  Checkbox,
  Image,
  Input,
  ModalBody,
  ModalHeader,
  useDisclosure,
} from "@nextui-org/react";
import {
  forgotPasswordApiRequest,
  resetPasswordApiRequest,
} from "../../services";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../../config/firebase.config";
import icons from "../../ultils/icons";

type FormData = {
  email: string;
  password: string;
};

const SignInPage = ({ navigate }: any) => {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  // state
  const [email, setEmail] = useState("");
  const [isSendTokenSuccess, setIsSendTokenSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // state reset password
  const [dataResetPassword, setDataResetPassword] = useState<any>({
    token: undefined,
    newPassword: "",
    confirmPassword: "",
  });

  // store remember
  const {
    email: emailRemember,
    isRemember,
    password,
    setInfoRemember,
    setIsRemember,
  } = useRememberStore();

  const formData = watch();

  // icons
  const { BiMailSend, MdOutlineLockReset } = icons;

  // api
  const { mutate: $handleLogin, isPending } = useLoginApi();
  const {
    mutate: $handleLoginWithSocial,
    isPending: isPendingLoginWithSocial,
  } = useLoginWithSocialApi();

  // state
  const { setToken, token } = useAuthStore();

  useEffect(() => {
    if (token) {
      navigate(path.STATISTICAL_MANAGE);
    }
  }, [token]);

  const onSubmit: any = () => {
    const loginData =
      formData?.email && formData?.password
        ? formData
        : isRemember && emailRemember && password
        ? { email: emailRemember, password }
        : null;

    if (!loginData) {
      toast.error("Please enter email and password");
      return;
    }
    $handleLogin(loginData as TLogin, {
      onSuccess: (response) => {
        if (response?.code === 200 && response?.data?.active) {
          setToken(response?.data?.token);
          toast.success("Login successfully !");
          if (isRemember) {
            setInfoRemember({
              email: loginData.email,
              password: loginData.password,
            });
          } else {
            setInfoRemember({
              email: null,
              password: null,
            });
          }
          navigate(path.STATISTICAL_MANAGE);
        } else if (response?.code === 200 && !response?.data?.active) {
          navigate(`${path.VERIFY_NEW_ACCOUNT}?token=${response?.data?.token}`);
        } else {
          toast.error(response?.message || "Login failure, please try again !");
        }
      },
      onError: (error: any) => {
        toast.error(
          error?.response?.data?.error || "Login failure, please try again !"
        );
      },
    });
  };

  const { isOpen, onOpen, onOpenChange, onClose } = useDisclosure();

  const handleForgotPassword = async () => {
    try {
      setIsLoading(true);
      const response = await forgotPasswordApiRequest(email);
      if (response?.code === 200) {
        setIsLoading(false);
        toast.success("Token was send to your email !");
        setIsSendTokenSuccess(true);
      }
    } catch (error: any) {
      setIsLoading(false);
      toast.error(
        error?.response?.data?.error ||
          "Forgot password failure, please try again !"
      );
      onClose();
    }
  };

  const handleResetPassword = async () => {
    try {
      setIsLoading(true);
      const response = await resetPasswordApiRequest({
        ...dataResetPassword,
        email,
      });
      if (response?.code === 200) {
        setIsLoading(false);
        toast.success("Change new password successfully !");
        setIsRemember(false);
        setInfoRemember({
          email: null,
          password: null,
        });
        onClose();
      } else {
        toast.error(
          response?.message || "Change new password failure, please try again !"
        );
        onClose();
      }
    } catch (error: any) {
      setIsLoading(false);
      toast.error(
        error?.response?.data?.error ||
          "Change new password failure, please try again !"
      );
      onClose();
    }
  };

  const handleLoginWithGoogle = async (e: any) => {
    e.preventDefault();
    try {
      const result = await signInWithPopup(auth, provider);
      const user: any = result.user;
      if (user?.stsTokenManager?.accessToken) {
        $handleLoginWithSocial(user?.stsTokenManager?.accessToken, {
          onSuccess: (response) => {
            if (response?.code === 200) {
              setToken(response?.data?.token);
              toast.success("Login with social successfully !");
              navigate(path.STATISTICAL_MANAGE);
            }
          },
          onError: (error: any) => {
            // toast.error(
            //   error?.response?.data?.error ||
            //     "Login failure, please try again !"
            // );
          },
        });
      }
    } catch (error) {
      // toast.error("Login failure, please try again !");
    }
  };

  return (
    <>
      <ModelNext
        // handleAction={onSubmitHandleCreateUser}
        isOpen={isOpen}
        onOpen={onOpen}
        onOpenChange={onOpenChange}
        // className="w-[50%]
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-photo-time-pink-light">
          Please enter your email
        </ModalHeader>
        <ModalBody className="">
          <>
            {!isSendTokenSuccess ? (
              <>
                <Input
                  placeholder="Enter your email"
                  onChange={(e: any) => setEmail(e.target.value)}
                ></Input>
                <ButtonCustom
                  onClick={handleForgotPassword}
                  variant="primary"
                  size="md"
                  className="w-full lg:text-base text-sm bg-photo-time-pink-main hover:bg-photo-time-pink-light flex justify-center items-center gap-2 md:gap-3 text-white"
                >
                  <span>Send Email</span>
                  {isLoading ? (
                    <Spin
                      className="text-white"
                      indicator={
                        <LoadingOutlined
                          className="white-spinner-icon text-white"
                          spin
                        />
                      }
                      size="small"
                    />
                  ) : (
                    <BiMailSend size={20}></BiMailSend>
                  )}
                </ButtonCustom>
              </>
            ) : (
              <>
                <Input defaultValue={email} disabled></Input>
                <Input
                  placeholder="Enter token"
                  onChange={(e: any) =>
                    setDataResetPassword({
                      ...dataResetPassword,
                      token: e.target.value,
                    })
                  }
                ></Input>
                <Input
                  type="password"
                  placeholder="Enter new password"
                  onChange={(e: any) =>
                    setDataResetPassword({
                      ...dataResetPassword,
                      newPassword: e.target.value,
                    })
                  }
                ></Input>
                <Input
                  type="password"
                  placeholder="Enter confirm password"
                  onChange={(e: any) =>
                    setDataResetPassword({
                      ...dataResetPassword,
                      confirmPassword: e.target.value,
                    })
                  }
                ></Input>
                <ButtonCustom
                  onClick={handleResetPassword}
                  variant="primary"
                  size="md"
                  className="w-full lg:text-base text-sm bg-photo-time-pink-main hover:bg-photo-time-pink-light flex justify-center items-center gap-2 lg:gap-3 text-white"
                >
                  <span>Reset Password</span>
                  {isLoading ? (
                    <Spin
                      className="text-white"
                      indicator={
                        <LoadingOutlined
                          className="white-spinner-icon text-white"
                          spin
                        />
                      }
                      size="small"
                    />
                  ) : (
                    <MdOutlineLockReset size={20}></MdOutlineLockReset>
                  )}
                </ButtonCustom>
              </>
            )}
          </>
        </ModalBody>
      </ModelNext>
      <div className="w-full flex-col gap-8 bg-white h-screen flex justify-center items-center">
        <p className="2xl:text-7xl lg:text-6xl md:text-5xl text-4xl  uppercase font-bold text-photo-time-pink-main">
          PHOTO TIME
        </p>
        <div className="xl:w-[40%] md:w-[60%] w-fit flex flex-col xl:rounded-2xl rounded-xl 2xl:py-[12vh] bg-opacity-95 xl:py-[10vh] lg:py-[7vh] md:py-[6vh] py-[5vh] 2xl:px-[2vw] xl:px-[2vw] lg:px-[3vw] md:px-[4vw] px-[3vw] bg-photo-time-pink-patel justify-center items-center">
          <div className="flex flex-col w-full justify-center items-center">
            {/* <div>
                  <img
                    src={phototime_logo}
                    alt="logo"
                    className="object-cover w-full h-full"
                  />
                </div> */}
            <p className="lg:text-2xl xl:text-4xl 2xl:text-5xl lg:-mt-8 text-2xl uppercase font-bold text-photo-time-pink-main lg:mb-6 text-center">
              Revenue Management
            </p>
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex w-full flex-col gap-6"
          >
            <InputField
              label="Email"
              placeholder="Enter your email"
              type="email"
              name="email"
              register={register}
              validate={{
                required: "Email is require",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "The email you entered does not match the format",
                },
              }}
              error={errors.email}
              defaultValue={emailRemember && isRemember ? emailRemember : ""}
            />

            <InputField
              label="Password"
              placeholder="Enter your password"
              type="password"
              name="password"
              register={register}
              validate={{
                required: "Password is required",
                minLength: {
                  value: 4,
                  message: "Password must be at least 4 characters",
                },
              }}
              error={errors.password}
              defaultValue={password && isRemember ? password : ""}
            />
            <div className="flex justify-between items-center">
              <div
                onClick={onOpen}
                className="hover:underline hover:text-photo-time-pink-light inline-block cursor-pointer "
              >
                <small className="text-photo-time-pink-main">
                  Your forgot password ?
                </small>
              </div>
              <div>
                <Checkbox
                  defaultSelected={isRemember}
                  onChange={() => {
                    setIsRemember(!isRemember);
                  }}
                  color="primary"
                >
                  <small className="text-sm font-semibold text-photo-time-pink-main">
                    Remember
                  </small>
                </Checkbox>
              </div>
            </div>

            <ButtonCustom
              variant="primary"
              size="md"
              className="w-full bg-white hover:bg-gray-100 flex justify-center items-center gap-3 text-black"
            >
              <span>Login</span>
              {isPending && (
                <Spin
                  indicator={
                    <LoadingOutlined
                      className="white-spinner-icon text-black"
                      spin
                    />
                  }
                  size="small"
                />
              )}
            </ButtonCustom>

            <ButtonCustom
              variant="primary"
              size="md"
              onClick={handleLoginWithGoogle}
              className="w-full bg-[#6eabfa] hover:bg-[#639deb] flex justify-center items-center gap-3 text-white"
            >
              <Image
                className="w-6 md:w-7"
                src={google_logo}
                alt="logo_google"
              />
              <span>Login with Google</span>
              {isPendingLoginWithSocial && (
                <Spin
                  indicator={
                    <LoadingOutlined className="white-spinner-icon" spin />
                  }
                  size="small"
                />
              )}
            </ButtonCustom>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(SignInPage);
